var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-md-none cart-total-mobile"},[_c('div',{staticClass:"cart-total-mobile__label"},[_vm._v(" Gesamt (brutto) ")]),_c('div',{staticClass:"cart-total-mobile__amount"},_vm._l((_vm.totals),function(total){return _c('CartItem',{key:total.label,attrs:{"suffix":total.suffix,"amount":total.price}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }